import React, { useState, useEffect, useMemo, useRef } from "react";
import Sidebar from "../sidebar/Sidebar";
import axios from "axios";
import api from "../../api/axios";
import group10 from "../images/Group 10.png";
import group11 from "../images/Group 11.png";
import group12 from "../images/Group 12.png";
import logo from "../images/recipt _ Logo 1.png";
import SyncLoader from "react-spinners/SyncLoader";
import PopUP from "../Popup/PopUP";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import { LuDownload } from "react-icons/lu";
function Customer() {
  const navigate = useNavigate();
  //state
  const [sidebarToggle, setSidebarToggle] = useState(true);
  const [payments, setPayments] = useState([]);
  const [filteredPayments, setFilteredPayments] = useState([]);
  const [inputdata, setInputdata] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [expandedRowId, setExpandedRowId] = useState(null);
  const [lodding, setLodding] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState(null);
  const [activeButton, setActiveButton] = useState("Orders");
  const [popup, setPopup] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [dragActive, setDragActive] = useState(false);
  const today = new Date();
  const date = today.toLocaleDateString("en-GB");
  const [userdata, setUserdata] = useState([]);
  const [recieptPopup, setRecieptPopup] = useState(false);
  const [selectedReciept, setSelectedReciept] = useState([]);
  const [expendedRow, setExpendedRow] = useState(null);
  const [projectID, setProjectID] = useState(null);
  const [orderID, setOrderID] = useState(null);
  const [customerID, setCustomerID] = useState(null)

  const fetchuserdata = async () => {
    try {
      setLodding(true);
      const res = await api.get("/order");
      setUserdata(res.data);
    } catch (error) {
      console.error(error)
    } finally {
      setLodding(false);
    }
  };
  useEffect(() => {
    fetchuserdata();
  }, []);

  const handlePopup = (tdataid, userid, paymentid) => {
    setCustomerID(tdataid)
    setOrderID(paymentid);
    setProjectID(userid);
    setPopup(true);
  };



  const addPriceandcount = userdata.map((userGroup) => {
    const usertotalcredits = userGroup?.orderDetails?.reduce(
      (acc, item) => acc + (Number(item.credits) || 0),
      0
    );
    const usertotalPrice = userGroup?.orderDetails?.reduce(
      (acc, item) => acc + (Number(item.finalPrice) || 0),
      0
    );

    return {
      ...userGroup,
      totalcredits: usertotalcredits,
      usertotalPrice: usertotalPrice,
    };
  });


  const total = userdata.reduce((userAcc, user) => {
    const userTotal = user.orderDetails.reduce(
      (acc, item) => acc + Number(item.finalPrice || 0),
      0
    );
    return userAcc + userTotal;
  }, 0);


  const allOrder = userdata?.flatMap((user) => user.orderDetails)

  const totalOrder = allOrder?.filter((order) => order.paymentStatus === "SUCCESS").length || 0


  const handlePDFupload = async (e) => {
    e.preventDefault();
    setPopup(false);
    try {
      const formData = new FormData();
      formData.append("selectedFile", selectedFile);
      formData.append("date", date);
      await api.put(
        `/update/${projectID}/${orderID}/${customerID}`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      toast.success("Certificate Upload successfull..");
    } catch (error) {
      console.error(error);
    }
  };

  //sidebar toggle
  const toggleClick = () => {
    setSidebarToggle(!sidebarToggle);
  };

  const handleRowClick = (id) => {
    setExpandedRowId(expandedRowId === id ? null : id);
  };

  //for input change
  const handleChange = (e) => {
    setInputdata(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    //filter data
    const fdata = addPriceandcount.filter((user) => {
      return (
        (user.first_name?.toString() || "").includes(inputdata) ||
        (user.last_name?.toString() || "").includes(inputdata) ||
        (user.email?.toString() || "").includes(inputdata) ||
        (user.mobile?.toString() || "").includes(inputdata) ||
        (user.organization?.toString() || "").includes(inputdata) ||
        (user.gst_no?.toString() || "").includes(inputdata) ||
        (user.state?.toString() || "").includes(inputdata) ||
        (user.address?.toString() || "").includes(inputdata) ||
        (user.city?.toString() || "").includes(inputdata) ||
        (user.credits?.toString() || "").includes(inputdata) ||
        (user.finalPrice?.toString() || "").includes(inputdata)
      );
    });
    setFilteredPayments(fdata);
  };

  //pagination
  const recordPerPage = 10;
  const lastIndex = currentPage * recordPerPage;
  const firstIndex = lastIndex - recordPerPage;
  const records = addPriceandcount.slice(firstIndex, lastIndex);
  const npage = Math.ceil(addPriceandcount.length / recordPerPage);

  const prevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const nextPage = () => {
    if (currentPage < npage) setCurrentPage(currentPage + 1);
  };

  //filter by ticket name

  //refresh
  const handleRefresh = () => {
    setInputdata("");
    setFilteredPayments([]);
    setCurrentPage(1);
  };






  const totleCustomers = useMemo(() => {
    return userdata.length;
  }, [userdata]);

  const handleSaveStatus = (newStatus) => {
    const updatedPayments = payments.map((payment) =>
      payment.id === selectedPayment.id
        ? { ...payment, statuus: newStatus }
        : payment
    );
    setPayments(updatedPayments);

    localStorage.setItem("payments", JSON.stringify(updatedPayments));
    setSelectedPayment(null);
  };

  const handlevewCustomer = (email) => {
    const datatoView = userdata.find((user) => user.email === email);

    navigate("/customers/view", { state: { data: datatoView } });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setSelectedFile(file);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    const file = e.dataTransfer.files[0];

    setSelectedFile(file);
  };

  const handleRecipt = (id) => {
    const user = userdata?.find((u) => u.orderDetails?.find((p) => p._id === id));

    const userOrder = user.orderDetails.find((d) => d._id === id)

    setSelectedReciept({
      ...userOrder,
      firstName: user.first_name,
      lastName: user.last_name,
      gst_no: user.gst_no,
      email: user.email,
      mobile: user.mobile
    })
    setRecieptPopup(true);
  };

  const subtotalprice = selectedReciept.usercart?.reduce(
    (acc, item) => acc + (Number(item.price) * Number(item.count) || 0),
    0
  );




  const closePopup = () => {
    setRecieptPopup(false);
  };

  const printRef = useRef(null);

  const handleDownloadPDF = async () => {
    if (!printRef.current) return;
    try {
      const style = document.createElement("style");
      style.innerHTML = ``;
      document.head.appendChild(style);
      // Generate canvas
      const canvas = await html2canvas(printRef.current, {
        scale: 4,
        useCORS: true,
        backgroundColor: "#ffffff",
        onclone: (documentClone) => {
          const clonedElement = documentClone.getElementById("printRefId");
          if (clonedElement) {
            clonedElement.style.fontFamily = "Arial, sans-serif";
            clonedElement.style.color = "black";
            clonedElement.style.border = "1px solid #000";
          }
        },
      });

      // Convert canvas to image
      const dataURL = canvas.toDataURL("image/png");

      // Create PDF
      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "px",
        format: "a4",
      });

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

      pdf.addImage(dataURL, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save("Receipt.pdf");
      // Remove dynamically added styles after PDF generation
      document.head.removeChild(style);

      setRecieptPopup(false);
    } catch (error) {
      console.error("Error generating PDF:", error);
    }
  };
  const handleExpendRow = (id) => {
    setExpendedRow((prev) => (prev === id ? null : id));
  };
  return (
    <>
      {/* header section-1 */}
      <div className="font-[Poppins] flex ">
        {sidebarToggle ? <div className="w-[320px] nirav"></div> : null}
        <Sidebar toggleClick={toggleClick} sidebarToggle={sidebarToggle} />
        <div className="w-[100%]">
          <div className=" 2xl:w-[90%] w-[95%] m-auto 2xl:mt-16 mt-10  xl:p-2 lg:p-10  p-2">
            <div className="sm:flex sm:justify-between sm:items-center">
              <h1 className="font-medium 2xl:text-2xl text-xl">
                Hello Admin 👋🏼
              </h1>
            </div>
            {/* section-2 */}
            <div className="border  mt-5 2xl:rounded-[30px] rounded-[20px] 2xl:px-14 px-7 2xl:py-8 py-5  bg-white shadow-sm">
              <div className="grid md:grid-cols-3">
                <div className="flex gap-5 mx-2 md:items-center max-md:my-5">
                  <img
                    className="max-2xl:w-[60px] max-2xl:h-[60px]"
                    src={group10}
                    alt="double human"
                  />
                  <div>
                    <h5 className="text-sm font-normal text-gray-500">
                      Total Customers
                    </h5>
                    <h1 className="font-semibold 2xl:text-3xl text-2xl my-1">
                      {totleCustomers}
                    </h1>
                  </div>
                </div>
                <div className="flex gap-5 md:justify-center mx-2 md:border-l-2 md:border-r-2 items-center max-md:my-5">
                  <img
                    className="max-2xl:w-[60px] max-2xl:h-[60px]"
                    src={group12}
                    alt="computer"
                  />
                  <div>
                    <h5 className="text-sm font-normal text-gray-500">
                      Total Orders
                    </h5>
                    <h1 className="font-semibold 2xl:text-3xl text-2xl my-1">
                      {totalOrder}
                    </h1>
                  </div>
                </div>
                <div className="flex gap-5 items-center mx-2 md:justify-end max-md:my-5">
                  <img
                    className="max-2xl:w-[60px] max-2xl:h-[60px]"
                    src={group11}
                    alt="sigle human"
                  />
                  <div>
                    <h5 className="text-sm font-normal text-gray-500">
                      Total Amount
                    </h5>
                    <h1 className="font-semibold 2xl:text-3xl text-2xl my-1">
                      ₹ {total.toFixed(2)}
                    </h1>
                  </div>
                </div>
              </div>
            </div>

            {recieptPopup && (
              <>
                <div
                  onClick={closePopup}
                  className="fixed inset-0 flex flex-col top-0 left-0 w-screen h-screen z-[9999] items-center justify-center bg-black bg-opacity-50"
                >
                  <button
                    className="bg-[#C65B1D] px-4 py-1 rounded-md text-white mb-2"
                    onClick={handleDownloadPDF}
                  >
                    Downolad PDF
                  </button>
                  <div
                    ref={printRef}
                    className="bg-white border flex flex-col gap-10  shadow-lg  w-[556px] h-[800px]  py-16 px-6 max-w-6xl"
                  >
                    <div className="flex justify-between items-start">
                      <div>
                        <h2 className="text-sm font-semibold">
                          {selectedReciept.firstName} {selectedReciept.lastName}
                        </h2>
                        <p className="text-xs text-[#646464]">
                          GSTIN : <span>{selectedReciept.gst_no}</span>{" "}
                        </p>
                      </div>
                      <div>
                        <img className="w-[100px] h-[20px]" src={logo} alt="" />
                      </div>
                    </div>

                    <div className="text-xs">
                      <p className="text-[#505050]">
                        <span className="text-sm font-medium">
                          Payment Receipt :
                        </span>
                        Transaction Reference :{" "}
                        <span className="text-[#646464]">
                          {selectedReciept.razorpayPaymentId}
                        </span>{" "}
                      </p>
                      <p className="text-[#646464]">
                        This is a payment receipt for your transaction on
                        Project RenewCred-1
                      </p>
                    </div>

                    <div>
                      <h2 className="text-sm text-[#646464]">
                        AMOUNT PAID:
                        <span className="font-semibold text-sm">
                          ₹{" "}
                          {selectedReciept.finalPrice}
                        </span>
                      </h2>
                    </div>

                    <div className="grid grid-cols-2 text-[#646464] text-xs">
                      <div className="leading-5">
                        <p>ISSUED To</p>
                        <p>Email: {selectedReciept.email}</p>
                        <p>Mo: {selectedReciept.mobile}</p>
                      </div>
                      <div>
                        <p>PAID ON</p>
                        <p>{selectedReciept.orderdate}</p>
                      </div>
                    </div>
                    <div className="">
                      <table className="min-w-[100%] table-auto  shadow-sm border border-separate border-spacing-0">
                        <thead className="bg-[#f0f0f0] font-medium">
                          <tr>
                            <th className="py-1   text-[#646464] whitespace-nowrap   text-xs text-center border-b border-gray-300 ">
                              DESCRIPTION
                            </th>
                            <th className=" py-1 w-[40px] text-[#646464] whitespace-nowrap  text-xs text-center border-b border-gray-300">
                              UNIT PRICE
                            </th>
                            <th className="py-1 w-[20px] text-[#646464] whitespace-nowrap   text-xs  text-center border-b border-gray-300">
                              QTY
                            </th>

                            <th className="py-1 w-[40px] text-[#646464] whitespace-nowrap  text-xs  text-center border-b border-gray-300">
                              AMOUNT
                            </th>
                          </tr>
                        </thead>
                        <tbody className="text-xs font-normal">
                          {selectedReciept.usercart.map((product, index) => {
                            return (
                              <tr key={index}>
                                <td className="py-1 border  text-[#5A607F] border-[#E4E7EC] text-center">
                                  {product.projectname}
                                </td>
                                <td className="py-1 border  text-[#5A607F] border-[#E4E7EC] text-center">
                                  {product.price}
                                </td>
                                <td className="py-1 border  text-[#5A607F] border-[#E4E7EC] text-center">
                                  {product.count}
                                </td>
                                <td className="py-1 border  text-[#5A607F] border-[#E4E7EC] text-center">
                                  {product.price * product.count}
                                </td>
                              </tr>
                            )
                          })}
                        </tbody>
                      </table>
                      <div className="flex justify-end space-y-4 text-xs mb-10">
                        {/* Billing Summary Section */}
                        <div className="w-36 p-2 space-y-1">
                          <div className="flex justify-between items-center">
                            <p className="font-medium">Total:</p>
                            <p className="font-normal">
                              {subtotalprice}
                            </p>
                          </div>
                          <div className="flex justify-between items-center">
                            <p className="font-medium text-[#00AC4F]">
                              Amount Paid:
                            </p>
                            <p className="font-normal text-[#00AC4F]">
                              ₹{" "}
                              {selectedReciept.finalPrice}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}

            {/* section-3 */}
            <div className="border mt-5 2xl:rounded-[30px] rounded-[20px] px-10 py-8  bg-white shadow-sm">
              <div className="mx-2 my-2 flex flex-wrap justify-between items-center">
                <div className="mb-3">
                  <h1 className="font-semibold 2xl:text-2xl text-xl">
                    All Customers
                  </h1>
                </div>
                {/* filter table data form */}
                <div className="flex items-center flex-wrap gap-1">
                  <form
                    className="filterinput"
                    action=""
                    onSubmit={handleSubmit}
                  >
                    <input
                      onChange={handleChange}
                      type="text"
                      name="inputdata"
                      value={inputdata}
                      className="bg-[#F9FBFF]  sm:px-5 max-sm:w-[68%] pl-3 2xl:py-2 py-[0.40rem] border border-gray-300  outline-none focus:ring-2 focus:ring-[#C65B1D] rounded-lg text-xs max-md:my-1"
                      placeholder="Search"
                    />
                    <button
                      type="submit"
                      className="mr-1 ml-3 cursor-pointer bg-[#C65B1D]  hover:shadow-md button text-white py-[0.4rem] 2xl:text-sm text-xs rounded-lg 2xl:px-3 px-2"
                    >
                      Search
                    </button>
                  </form>
                  {/* filter table data by ticketname */}
                  <div className="flex justify-between items-center flex-wrap">
                    <i
                      onClick={handleRefresh}
                      className="fa-solid fa-arrows-rotate ml-2 cursor-pointer border border-gray-300 px-2 2xl:py-[0.45rem] py-[0.40rem] rounded-md bg-[#F9FBFF]"
                    ></i>
                  </div>
                </div>
              </div>

              {popup && (
                <div className="fixed inset-0 top-0 left-0 w-screen h-screen z-[9999]  flex items-center justify-center bg-black bg-opacity-50">
                  <form
                    onSubmit={handlePDFupload}
                    className="bg-white border rounded-[24px]  shadow-lg border-[#C65B1D] w-[556px]   p-10 max-w-6xl"
                  >
                    <div className="text-end">
                      <i
                        onClick={() => setPopup(false)}
                        class="fa-solid fa-xmark text-lg cursor-pointer"
                      ></i>
                    </div>

                    <div className="text-center">
                      <h3 className="text-[#C65B1D] text-3xl font-medium">
                        Upload Doc
                      </h3>
                    </div>

                    <div
                      onDragOver={handleDragOver}
                      onDragLeave={handleDragLeave}
                      onDrop={handleDrop}
                      className={`border-2 border-dashed border-[#C65B1D] flex justify-center flex-col gap-4 items-center p-10 rounded-[20px] mt-10 ${dragActive ? "bg-orange-50" : ""
                        } cursor-pointer`}
                    >
                      <input
                        type="file"
                        accept=".png,.jpg,.jpeg,.pdf"
                        onChange={handleFileChange}
                        className="hidden"
                        id="fileInput"
                      />
                      <label
                        htmlFor="fileInput"
                        className="text-center cursor-pointer"
                      >
                        <i className="fa-solid fa-arrow-up-from-bracket text-[#686868] text-xl"></i>
                        <h3 className="text-[22px] mt-2">
                          Drag & drop or Browse
                        </h3>
                        <p className="text-[#B5B7C0] text-sm">
                          (Only PNG, JPG, PDF files allowed.)
                        </p>
                      </label>

                      {selectedFile && (
                        <p className="text-green-700 mt-4 text-sm">
                          Selected: {selectedFile.name}
                        </p>
                      )}
                    </div>

                    <div>
                      <button
                        type="submit"
                        className="bg-[#C65B1D] w-full mt-10 p-2 rounded-lg text-white"
                      >
                        Save
                      </button>
                    </div>
                  </form>
                </div>
              )}

              {/* section-4 table */}
              <div className="mt-6 relative overflow-x-auto  overflow-y-hidden">
                <table className="w-full border-collapse border-spacing-0">
                  <thead>
                    <tr className="text-[#b5b7c0] m-12 font-medium">
                      <th className="text-center">Sr no</th>
                      <th>Customer Name</th>
                      <th>Phone No.</th>
                      <th>Email</th>
                      <th className="text-center">Total Credits</th>
                      <th className="text-center">Total Amount</th>
                      <th></th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {lodding ? (
                      <tr>
                        <td colSpan="11" className="text-center">
                          <div className="flex justify-center items-center w-full h-full">
                            <SyncLoader
                              margin={1}
                              speedMultiplier={1}
                              color={"#069ea1"}
                              loading={lodding}
                              size={10}
                            />
                          </div>
                        </td>
                      </tr>
                    ) : (
                      (filteredPayments.length > 0
                        ? filteredPayments
                        : addPriceandcount
                      ).map((tdata, index) => {
                        const serialNumber = firstIndex + index + 1;
                        // const filename = tdata.payments.map((file) =>
                        //   file.selectedFile?.split("-").pop()
                        // );
                        return (
                          <React.Fragment key={index}>
                            <tr
                              className="h-10 text-sm m-12 cursor-pointer font-medium"
                              style={{ cursor: "pointer" }}
                            >
                              <td className="text-center">{serialNumber}</td>
                              <td>
                                {tdata.first_name} {tdata.last_name}
                              </td>
                              <td>{tdata.mobile}</td>
                              <td>{tdata.email}</td>
                              <td className="text-center">{tdata.totalcredits}</td>
                              <td className="text-center">₹ {tdata.usertotalPrice.toFixed()}</td>
                              <td>
                                <button
                                  onClick={() => handlevewCustomer(tdata.email)}
                                  className="bg-[#F9EFE8] text-[#C65B1D] rounded-[4px] cursor-pointer font-medium px-2 py-[0.15rem]"
                                >
                                  View
                                </button>
                              </td>
                              <td>
                                {" "}
                                <i
                                  onClick={() => handleRowClick(index)}
                                  className={`fa-solid ${expandedRowId === index
                                    ? "fa-minus"
                                    : "fa-plus"
                                    }  cursor-pointer`}
                                ></i>
                              </td>
                            </tr>
                            {expandedRowId === index && (
                              <tr>
                                <td colSpan="12">
                                  <div className="flex gap-6 mt-2">
                                    <button
                                      onClick={() => setActiveButton("Orders")}
                                      className={`${activeButton === "Orders"
                                        ? " text-[#C65B1D] e "
                                        : "text-[#4D4D4D]"
                                        } font-medium text-sm leading-5 cursor-pointer `}
                                    >
                                      Orders
                                    </button>

                                    <button
                                      onClick={() => setActiveButton("Address")}
                                      className={`${activeButton === "Address"
                                        ? " text-[#C65B1D] e "
                                        : "text-[#4D4D4D]  "
                                        } font-medium text-sm leading-5 cursor-pointer `}
                                    >
                                      Address
                                    </button>
                                  </div>

                                  {/* table */}
                                  {activeButton === "Orders" && (
                                    <section className="mt-2 overflow-x-auto">
                                      <table className="min-w-[100%] table-auto border border-[#E5E5E5] border-separate border-spacing-0 rounded-t-lg shadow-sm">
                                        <thead className="bg-[#FCFCFC] rounded-t-lg">
                                          <tr className="">
                                            <th
                                              className={`whitespace-nowrap p-2 pl-4 rounded-tl-lg w-[100px]  border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                            >
                                              <div className="border-r pr-8 border-[#E5E5E5]">
                                                Order ID
                                              </div>
                                            </th>
                                            <th
                                              className={`whitespace-nowrap p-2 pl-0 border-b w-[150px] border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                            >
                                              <div className="border-r pr-8  border-[#E5E5E5]">
                                                Order Date
                                              </div>
                                            </th>

                                            <th
                                              className={`whitespace-nowrap  p-2 pl-0  border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                            >
                                              <div className="border-r pr-8  border-[#E5E5E5]">
                                                Transaction ID
                                              </div>
                                            </th>

                                            <th
                                              className={`whitespace-nowrap p-2  pl-0 w-[200px] border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                            >
                                              <div className="border-r pr-8  border-[#E5E5E5]">
                                                Credits
                                              </div>
                                            </th>
                                            <th
                                              className={`whitespace-nowrap p-2 w-[200px] pl-0 border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                            >
                                              <div className="border-r pr-8  border-[#E5E5E5]">
                                                Total Amount
                                              </div>
                                            </th>

                                            <th
                                              className={`whitespace-nowrap p-2 pl-0 rounded-tr-lg  border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                            >
                                              <div className="  border-[#E5E5E5]">
                                                Receipt
                                              </div>
                                            </th>
                                            <th
                                              className={`whitespace-nowrap p-2 pl-0 rounded-tr-lg  border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                            >
                                              <div className="  border-[#E5E5E5]"></div>
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody className="bg-[#FFFFFF]">
                                          {tdata.orderDetails.map(
                                            (payment, index) => {
                                              return (
                                                <React.Fragment key={index}>
                                                  <tr>
                                                    <td className="whitespace-nowrap pl-4 py-2 text-[#1A1A1A] text-sm max-xl:text-xs leading-5 font-normal border-b text-start border-gray-300">
                                                      {payment.razorpayOrderId}
                                                    </td>
                                                    <td className="whitespace-nowrap  py-2 text-[#1A1A1A] text-sm max-xl:text-xs leading-5 font-normal border-b text-start border-gray-300">
                                                      {payment.orderdate}
                                                    </td>
                                                    <td className="whitespace-nowrap  py-2 text-[#1A1A1A] text-sm max-xl:text-xs leading-5 font-normal border-b text-start border-gray-300">
                                                      {
                                                        payment.razorpayPaymentId
                                                      }
                                                    </td>
                                                    <td className="whitespace-nowrap  py-2 text-[#1A1A1A] text-sm max-xl:text-xs leading-5 font-normal border-b text-start border-gray-300">
                                                      {payment.credits}
                                                    </td>
                                                    <td className="whitespace-nowrap  py-2 text-[#1A1A1A] text-sm max-xl:text-xs leading-5 font-normal border-b text-start border-gray-300">
                                                      ₹ {payment.finalPrice}
                                                    </td>

                                                    <td className="whitespace-nowrap  py-2 text-[#1A1A1A] text-sm max-xl:text-xs leading-5 font-normal border-b text-start border-gray-300">
                                                      <i
                                                        onClick={() =>
                                                          handleRecipt(
                                                            payment._id
                                                          )
                                                        }
                                                        className="fa-solid fa-download cursor-pointer"
                                                      ></i>
                                                    </td>

                                                    <td>
                                                      <i
                                                        onClick={() =>
                                                          handleExpendRow(index)
                                                        }
                                                        className={`fa-solid ${expendedRow === index
                                                          ? "fa-minus"
                                                          : "fa-plus"
                                                          }  cursor-pointer`}
                                                      ></i>
                                                    </td>
                                                  </tr>
                                                  {expendedRow === index && (
                                                    <>
                                                      <tr>
                                                        <td colSpan="12">
                                                          <div className="flex gap-6 mt-2">
                                                            <table className="min-w-[100%] my-2 table-auto border border-[#E5E5E5] border-separate border-spacing-0 rounded-t-lg shadow-sm">
                                                              <thead className="bg-[#FCFCFC] rounded-t-lg">
                                                                <tr className="">
                                                                  <th
                                                                    className={`whitespace-nowrap p-2 pl-4 rounded-tl-lg   border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                                                  >
                                                                    <div className="border-r pr-8 border-[#E5E5E5]">
                                                                      Project ID
                                                                    </div>
                                                                  </th>
                                                                  <th
                                                                    className={`whitespace-nowrap p-2 pl-0 border-b  border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                                                  >
                                                                    <div className="border-r pr-8  border-[#E5E5E5]">
                                                                      Project
                                                                      Name
                                                                    </div>
                                                                  </th>
                                                                  <th
                                                                    className={`whitespace-nowrap p-2 pl-0  border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                                                  >
                                                                    <div className="border-r pr-8  border-[#E5E5E5]">
                                                                      Methodology
                                                                    </div>
                                                                  </th>
                                                                  <th
                                                                    className={`whitespace-nowrap  p-2 pl-0  border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                                                  >
                                                                    <div className="border-r pr-8  border-[#E5E5E5]">
                                                                      Credits
                                                                      (Tones)
                                                                    </div>
                                                                  </th>

                                                                  <th
                                                                    className={`whitespace-nowrap  p-2 pl-0  border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                                                  >
                                                                    <div className="border-r pr-8  border-[#E5E5E5]">
                                                                      Unit Price
                                                                    </div>
                                                                  </th>
                                                                  <th
                                                                    className={`whitespace-nowrap  p-2 pl-0  border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                                                  >
                                                                    <div className="border-r pr-8  border-[#E5E5E5]">
                                                                      Amount
                                                                    </div>
                                                                  </th>
                                                                  <th
                                                                    className={`whitespace-nowrap p-2 pl-0 rounded-tr-lg  border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-center `}
                                                                  >
                                                                    <div className="  border-[#E5E5E5]">
                                                                      Certificate
                                                                    </div>
                                                                  </th>
                                                                </tr>
                                                              </thead>
                                                              <tbody>
                                                                {payment.usercart.map(
                                                                  (
                                                                    user,
                                                                    index
                                                                  ) => {
                                                                    const filename =
                                                                      user.certificateURL
                                                                        ?.split(
                                                                          "-"
                                                                        )
                                                                        .pop();

                                                                    return (
                                                                      <tr
                                                                        key={
                                                                          index
                                                                        }
                                                                      >
                                                                        <td className="pl-4">
                                                                          {
                                                                            user.projectid
                                                                          }
                                                                        </td>
                                                                        <td className="pl-0">
                                                                          {
                                                                            user.projectname
                                                                          }
                                                                        </td>
                                                                        <td>
                                                                          {
                                                                            user.methodology
                                                                          }
                                                                        </td>
                                                                        <td className="pl-0">
                                                                          {
                                                                            user.count
                                                                          }
                                                                        </td>

                                                                        <td className="pl-0">
                                                                          ₹ {
                                                                            user.price
                                                                          }
                                                                        </td>
                                                                        <td className="pl-0">
                                                                          ₹ {user.price *
                                                                            user.count}
                                                                        </td>
                                                                        <td className="pl-0 text-center">
                                                                          {filename ? (
                                                                            <button
                                                                              onClick={() =>
                                                                                user.certificateURL &&
                                                                                window.open(
                                                                                  user.certificateURL,
                                                                                  "_blank"
                                                                                )
                                                                              }
                                                                              className="text-[#0167FF] text-xl"
                                                                            >
                                                                              <LuDownload />
                                                                            </button>
                                                                          ) : (
                                                                            <button
                                                                              onClick={() => {
                                                                                handlePopup(
                                                                                  tdata._id,
                                                                                  user._id,
                                                                                  payment._id
                                                                                );
                                                                              }}
                                                                              className="bg-[#F9EFE8] text-[#C65B1D] rounded-[4px] cursor-pointer font-medium px-2 py-[0.15rem]"
                                                                            >
                                                                              Upload
                                                                            </button>
                                                                          )}
                                                                        </td>
                                                                      </tr>
                                                                    );
                                                                  }
                                                                )}
                                                              </tbody>
                                                            </table>
                                                          </div>
                                                        </td>
                                                      </tr>
                                                    </>
                                                  )}
                                                </React.Fragment>
                                              );
                                            }
                                          )}
                                        </tbody>
                                      </table>
                                    </section>
                                  )}

                                  {activeButton === "Address" && (
                                    <table className="min-w-[100%] my-2 table-auto border border-[#E5E5E5] border-separate border-spacing-0 rounded-t-lg shadow-sm">
                                      <thead className="bg-[#FCFCFC] rounded-t-lg">
                                        <tr className="">
                                          <th
                                            className={`whitespace-nowrap p-2 pl-4 rounded-tl-lg   border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                          >
                                            <div className="border-r pr-8 border-[#E5E5E5]">
                                              Company Name
                                            </div>
                                          </th>
                                          <th
                                            className={`whitespace-nowrap p-2 pl-0 border-b  border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                          >
                                            <div className="border-r pr-8  border-[#E5E5E5]">
                                              GST
                                            </div>
                                          </th>

                                          <th
                                            className={`whitespace-nowrap  p-2 pl-0  border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                          >
                                            <div className="border-r pr-8  border-[#E5E5E5]">
                                              Address
                                            </div>
                                          </th>
                                          <th
                                            className={`whitespace-nowrap  p-2 pl-0  border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                          >
                                            <div className="border-r pr-8  border-[#E5E5E5]">
                                              State
                                            </div>
                                          </th>
                                          <th
                                            className={`whitespace-nowrap  p-2 pl-0  border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                          >
                                            <div className="border-r pr-8  border-[#E5E5E5]">
                                              City
                                            </div>
                                          </th>
                                          <th
                                            className={`whitespace-nowrap p-2 pl-0 rounded-tr-lg  border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                          >
                                            <div className="  border-[#E5E5E5]">
                                              Pincode
                                            </div>
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>

                                        <tr >
                                          <td className="pl-4">
                                            {tdata.organization}
                                          </td>
                                          <td className="pl-0">
                                            {tdata.gst_no}
                                          </td>

                                          <td className="pl-0">
                                            {tdata.address}
                                          </td>

                                          <td className="pl-0">
                                            {tdata.state}
                                          </td>
                                          <td className="pl-0">
                                            {tdata.city}
                                          </td>
                                          <td className="pl-0">
                                            {tdata.postcade}
                                          </td>
                                        </tr>

                                      </tbody>
                                    </table>
                                  )}

                                  {activeButton === "Certificates" && (
                                    <section className="mt-2 overflow-x-auto">
                                      <table className="min-w-[100%] table-auto border border-[#E5E5E5] border-separate border-spacing-0 rounded-t-lg shadow-sm">
                                        <thead className="bg-[#FCFCFC] rounded-t-lg">
                                          <tr className="">
                                            <th
                                              className={`whitespace-nowrap p-2 pl-4 rounded-tl-lg   border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                            >
                                              <div className="border-r pr-8 border-[#E5E5E5]">
                                                Certificate Name
                                              </div>
                                            </th>
                                            <th
                                              className={`whitespace-nowrap p-2 pl-0 border-b  border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                            >
                                              <div className="border-r pr-8  border-[#E5E5E5]">
                                                Date
                                              </div>
                                            </th>
                                            <th
                                              className={`whitespace-nowrap p-2 pl-0  border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                            >
                                              <div className="border-r pr-8  border-[#E5E5E5]">
                                                Order ID
                                              </div>
                                            </th>

                                            <th
                                              className={`whitespace-nowrap p-2 pl-0 rounded-tr-lg  border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                            >
                                              <div className="  border-[#E5E5E5]">
                                                Action
                                              </div>
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody className="bg-[#FFFFFF]">
                                          {tdata.payments?.usercart?.map(
                                            (payment) => {
                                              return (
                                                <tr>
                                                  <td className="whitespace-nowrap pl-4 py-2 text-[#1A1A1A] text-sm max-xl:text-xs leading-5 font-normal border-b text-start border-gray-300"></td>
                                                  <td className="whitespace-nowrap pl-4 py-2 text-[#1A1A1A] text-sm max-xl:text-xs leading-5 font-normal border-b text-start border-gray-300"></td>
                                                  <td className="whitespace-nowrap pl-4 py-2 text-[#1A1A1A] text-sm max-xl:text-xs leading-5 font-normal border-b text-start border-gray-300">
                                                    {payment.projectid}
                                                  </td>
                                                  <td className="whitespace-nowrap pl-4 py-2 text-[#1A1A1A] text-sm max-xl:text-xs leading-5 font-normal border-b text-start border-gray-300">
                                                    {/* {filename ? (
                                                      <button className="text-[#C65B1D]">
                                                        download
                                                      </button>
                                                    ) : (
                                                      <button
                                                        onClick={() => {
                                                          handlePopup(
                                                            payment._id
                                                          );
                                                        }}
                                                        className="text-[#C65B1D]"
                                                      >
                                                        Upload
                                                      </button>
                                                    )} */}
                                                  </td>
                                                </tr>
                                              );
                                            }
                                          )}
                                        </tbody>
                                      </table>
                                    </section>
                                  )}
                                </td>
                              </tr>
                            )}
                          </React.Fragment>
                        );
                      })
                    )}
                  </tbody>
                </table>
              </div>

              {selectedPayment && (
                <PopUP
                  currentStatus={selectedPayment.status}
                  onClose={() => setSelectedPayment(null)}
                  onSave={handleSaveStatus}
                />
              )}
              {/* pagination */}
              <div className="flex justify-between items-center mt-4">
                <button
                  onClick={prevPage}
                  disabled={currentPage === 1}
                  className={`px-4 py-2 bg-[#C65B1D] hover:bg-[#C65B1D] text-white rounded-lg mr-2 transition duration-200 ease-in-out ${currentPage === 1
                    ? "opacity-50 cursor-not-allowed"
                    : "cursor-pointer"
                    }`}
                  aria-label="Previous Page"
                >
                  Prev
                </button>

                <button
                  onClick={nextPage}
                  disabled={currentPage === npage}
                  className={`px-4 py-2 bg-[#C65B1D] hover:bg-[#C65B1D] text-white rounded-lg ml-2 transition duration-200 ease-in-out ${currentPage === npage
                    ? "opacity-50 cursor-not-allowed"
                    : "cursor-pointer"
                    }`}
                  aria-label="Next Page"
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Customer;
